<template>
  <div :style="styleDivisor"></div>
</template>

<script>
export default {
  name: 'commonDivisor',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    borderSide: {
      type: String,
      default: 'top',
    },
    borderWidth: {
      type: Number,
      default: 1,
    },
    borderHeight: {
      type: Number,
    },
    borderColor: {
      type: String,
      default: 'gray-200',
    },
  },
  computed: {
    styleDivisor() {
      const style = {
        [`border-${this.borderSide}`]: `${this.borderWidth}px solid var(--${this.borderColor})`,

      };

      if (this.borderHeight) {
        style.height = `${this.borderHeight}px`;
      }

      return style;
    },
  },
};
</script>
